export default function errorsLogin(error, remainingAttempts) {
  const wrongCredentialsText =
    remainingAttempts === 0
      ? 'Usuário bloqueado. Solicite acesso ao seu administrador.'
      : `Senha incorreta. ${remainingAttempts} tentativas restantes.`;

  const errors = {
    'User not found': 'Usuário não encontrado.',
    'Wrong credentials': wrongCredentialsText,
    'No customer provided':
      'Cliente não informado. Utilize o parâmetro customer na URL.',
    'Customer not found': 'Cliente não encontrado.',
    'User already created': 'Usuário já existente.',
    'User didnt set a password yet':
      'Você ainda não criou uma senha. Verifique seu e-mail.',
    'Too many requests, user blocked':
      'Limite de tentativas excedido. Aguarde alguns minutos.',
    'jwt expired': 'Tempo expirado. Solicite uma nova redefinição de senha.',
    'Wrong code': 'Código inválido. Verifique seu e-mail.',
    'Code expired': 'Código expirado. Solicite uma nova redefinição de senha.',
    'User is blocked':
      'Usuário bloqueado. Solicite o desbloqueio ao seu administrador.',
    'Password expired': 'Senha expirada. Redirecionando para a recuperação...',
    'The new password must be different':
      'A senha deve ser diferente da anterior.',
  };

  return errors[error];
}
